angular.module('routes.simulation.widgets.SimulationWidgetsController', [
  'stack'
])

/**
 * The SimulationWidgetsController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class SimulationWidgetsController
 * @constructor
 * @module routes.simulation.widgets.SimulationWidgetsController
 **/
.controller('SimulationWidgetsController', [
  '$scope',
  '$state',
  'constants',
  'WidgetsService',
  function ($scope, $state, constants, WidgetsService) {
    'use strict';

    $scope.constants = null;

    $scope.form = {
      template: null,
      schema: null,
      form: null,
      model: {}
    };

    $scope.state = $state;

    $scope.widgets = {
      list: [],
      current: null
    };

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      $scope.constants = constants.constants;
    }

    /**
     * Defines the current state
     */
    function defineCurrentWidget() {
      if (
        $state.params.widgetId
        && $state.params.widgetId !== 'events'
        && $state.params.widgetId !== 'sbar'
      ) {
        $scope.widgets.current = WidgetsService.get($state.params.widgetId);
        $scope.widgets.formatted = WidgetsService.get($state.params.widgetId, true);
        // $scope.widgets.current.content.widgets = WidgetsService
        //   .getFromList($scope.widgets.current.content.widgets);

        // schema = ModelsService.find('schemas', 'label', 'widgets');
        // $scope.form.schema = schema.content.schema;
        // $scope.form.form = schema.content.form;
        // $scope.form.model = WidgetsService.populateModel($scope.widgets.current);
      } else {
        $scope.widgets.current = null;
      }
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      if ($scope.simulation) {
        defineConstants();
        // defineWidgetsList();
        defineCurrentWidget();
      }
    }
    initialize();
  }
]);
